export const UPLOAD_ACCEPT = 'image/png, image/gif, image/jpeg, image/jpg'

export const POST_IMAGES = 'posts/images/'
